
const digest = 'bd7e40deb1bc4d0fd8f498b36a47b53f7dac3f5edda95e9788cf7151f7f162cb';
const classes = {"wrapper":"_wrapper_1i52l_1","content":"_content_1i52l_8","date":"_date_1i52l_14","name":"_name_1i52l_18","title":"_title_1i52l_22","scoring":"_scoring_1i52l_27","score":"_score_1i52l_37","controls":"_controls_1i52l_45"};
const css = `._wrapper_1i52l_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1i52l_1 ._content_1i52l_8 {
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  gap: 7px;
}
._wrapper_1i52l_1 ._content_1i52l_8 ._date_1i52l_14 {
  color: #3e3f42;
  font-size: 14px;
}
._wrapper_1i52l_1 ._content_1i52l_8 ._name_1i52l_18 {
  color: #3e3f42;
  font-size: 14px;
}
._wrapper_1i52l_1 ._content_1i52l_8 ._title_1i52l_22 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._wrapper_1i52l_1 ._scoring_1i52l_27 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-left: 1px solid #eaedf3;
  padding: 24px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
}
._wrapper_1i52l_1 ._scoring_1i52l_27 ._score_1i52l_37 {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  height: fit-content;
  border-radius: 15px;
  color: #ffffff;
}
._wrapper_1i52l_1 ._controls_1i52l_45 {
  min-width: 230px;
  max-width: 230px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 12px;
}
._wrapper_1i52l_1 ._controls_1i52l_45 ._score_1i52l_37 {
  font-size: 14px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  